import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { ShowDateTime } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type TenantTokenUsageViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  providerValue?: { displayId: string; id: string } | null;
  provider: string;
  modelValue?: { displayId: string; id: string } | null;
  model: string;
  promptTokensValue?: { displayId: string; id: string } | null;
  promptTokens: number;
  completionTokensValue?: { displayId: string; id: string } | null;
  completionTokens: number;
  totalTokensValue?: { displayId: string; id: string } | null;
  totalTokens: number;
  conversationValue: { displayId: string; id: string } | null;
  conversationUserValue: { displayId: string; id: string } | null;
  timestampValue?: { displayId: string; id: string } | null;
  timestamp: Date | null;
  totalTimeMsValue?: { displayId: string; id: string } | null;
  totalTimeMs: number;
  llmTimeMsValue?: { displayId: string; id: string } | null;
  llmTimeMs: number;
  toolsTimeMsValue?: { displayId: string; id: string } | null;
  toolsTimeMs: number;
  ragTimeMsValue?: { displayId: string; id: string } | null;
  ragTimeMs: number | undefined;
  firstTokenMsValue?: { displayId: string; id: string } | null;
  firstTokenMs: number | undefined;
  llmCallCountValue?: { displayId: string; id: string } | null;
  llmCallCount: number;
  toolCallCountValue?: { displayId: string; id: string } | null;
  toolCallCount: number;
  ragChunksCountValue?: { displayId: string; id: string } | null;
  ragChunksCount: number | undefined;
  abTestConditionValue?: { displayId: string; id: string } | null;
  abTestCondition: string;
};

export const TenantTokenUsageViewForm: React.FC<TenantTokenUsageViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      provider = "",
      model = "",
      promptTokens = 0,
      completionTokens = 0,
      totalTokens = 0,
      conversationValue,
      conversationUserValue,
      timestamp = null,
      totalTimeMs = 0,
      llmTimeMs = 0,
      toolsTimeMs = 0,
      ragTimeMs = 0,
      firstTokenMs = 0,
      llmCallCount = 0,
      toolCallCount = 0,
      ragChunksCount = 0,
      abTestCondition = "",
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupTenantTokenUsageLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={provider}
                  label={langStore.TenantTokenUsageProviderLabel}
                />
                <ShowMultiLine
                  value={model}
                  label={langStore.TenantTokenUsageModelLabel}
                />
                <ShowNumber
                  value={promptTokens}
                  label={langStore.TenantTokenUsagePromptTokensLabel}
                />
                <ShowNumber
                  value={completionTokens}
                  label={langStore.TenantTokenUsageCompletionTokensLabel}
                />
                <ShowNumber
                  value={totalTokens}
                  label={langStore.TenantTokenUsageTotalTokensLabel}
                />
                <ShowReference
                  label={langStore.TenantTokenUsageConversationLabel}
                  selectedValue={langStore.displayIdByLang(
                    conversationValue?.displayId
                  )}
                />
                <ShowReference
                  label={langStore.TenantTokenUsageConversationUserLabel}
                  selectedValue={langStore.displayIdByLang(
                    conversationUserValue?.displayId
                  )}
                />
                <ShowDateTime
                  value={timestamp}
                  label={langStore.TenantTokenUsageTimestampLabel}
                />
                <ShowNumber
                  value={totalTimeMs}
                  label={langStore.TenantTokenUsageTotalTimeMsLabel}
                />
                <ShowNumber
                  value={llmTimeMs}
                  label={langStore.TenantTokenUsageLlmTimeMsLabel}
                />
                <ShowNumber
                  value={toolsTimeMs}
                  label={langStore.TenantTokenUsageToolsTimeMsLabel}
                />
                <ShowNumber
                  value={ragTimeMs}
                  label={langStore.TenantTokenUsageRagTimeMsLabel}
                />
                <ShowNumber
                  value={firstTokenMs}
                  label={langStore.TenantTokenUsageFirstTokenMsLabel}
                />
                <ShowNumber
                  value={llmCallCount}
                  label={langStore.TenantTokenUsageLlmCallCountLabel}
                />
                <ShowNumber
                  value={toolCallCount}
                  label={langStore.TenantTokenUsageToolCallCountLabel}
                />
                <ShowNumber
                  value={ragChunksCount}
                  label={langStore.TenantTokenUsageRagChunksCountLabel}
                />
                <ShowMultiLine
                  value={abTestCondition}
                  label={langStore.TenantTokenUsageAbTestConditionLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
